export class PopupOptions {
  public HeaderSize: number;

  constructor() {
    this.HeaderSize = 1;
  }
}